import React from 'react';
import { withTranslation } from 'react-i18next';
import Person from '../../objects/Person';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import PersonListContainer from '../common/PersonListContainer';

class BInventoryRecordsContactPersonListContainer extends React.Component {
  render() {
    return this.props.values.inventoryContactPersons ? (
      <AccordionWrapper
        {...this.props}
        collapsed={false}
        accordionTitle="building.summary.page.inventory.records.contact.person.list.container.title"
        tooltip="building.summary.page.inventory.records.contact.person.list.container.tooltip"
        render={this.getContainerBody}
        className="containerReducedWhiteSpace"
      />
    ) : null;
  }

  getContainerBody = () => {
    if (this.props.values.inventoryContactPersons == null)
      this.props.values.inventoryContactPersons = [];
    return (
      <PersonListContainer
        {...this.props}
        newPersonEntity={Person}
        arrayPropName="inventoryContactPersons"
        showEmailHandler={true}
        showNoEmailAvailable={true}
        showRole={true}
        sort={true}
      />
    );
  };
}

export default withTranslation()(BInventoryRecordsContactPersonListContainer);
